export default __webpack_public_path__ + "static/media/align-justify.90285f1f.svg";